module.exports = __webpack_public_path__ + "img/27_86.020be36f.png";